import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, DetailCard, Dialog, GenericTable, Loader, TableColumnCustomizer, tCell, toastMessage } from "../utils";
import dayjs from "dayjs";
import { findDeepValue, removeSpecialChars, capitalizeCamelCase, formatDate } from "../../services/functions";
import { useCheckpointDataForExcelDownload, useCheckpoints, usePlant, useUserDetail, useUserPermissions, useUserTableHeader } from "../../services/hooks";
import { useLazyGetCheckpointEntryDetailQuery, useUpdateUserTableHeadersMutation, useVehicleDetailsMutation } from "../../api/vmsSlice";
import { useCheckpointData } from "../../services/hooks";
import theme, { buttonClasses } from "../utils/theme";
import { PopOver } from "../utils";
import { DatePicker, SearchDropdown, Dropdown } from "../utils";
import { CheckIcon, EyeIcon } from "../../services/icons";
import { Card, Grid } from "@mui/material";
import { useSocketContext } from "../../context/socketContext";
import { usePlantContext } from "../../context/plantContext";
import { dataIconMap } from "../Checkpoint/Checkpoint";
import "./AllTrips.css";
import VehicleJourneyDetailCard, { VehicleJourneyDetailSkeleton } from "../Checkpoint/GenerateDetail";
import EditVehicleDialog from "../utils/EditVehicleDialog";
import { downloadExcel } from "react-export-table-to-excel";
import { toast } from "react-toastify";

const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};

function deduplicateEntries(data) {
	let res = [];
	let hash = {};
	for (let i = data.length - 1; i >= 0; i--) {
		if (hash[data[i]._id]) {
			continue;
		}
		hash[data[i]._id] = true;
		res.unshift(data[i]);
	}
	return res;
}
export default function AllCheckpointData({ forwordLink, listOnly = false, dummyTourData, isTourMode, shouldRunTour, showPagination = false, showHeading = true, plantArray=false, noSocketEvent=false,handletripDetail, showDownloadExcelButton = false,  onTotalCountChange }) {
	const navigate = useNavigate();
	const { plantId } = usePlantContext();
	const [anchorEl, setAnchorEl] = useState(null);
	const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
	const endOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
	const todayDate = new Date();
	const oneDayAgoDate = new Date();
	oneDayAgoDate.setDate(todayDate.getDate() - 1);
	const [filter, setFilter] = useState({
		start: startOfDay(oneDayAgoDate).toISOString(),
		end: endOfDay(todayDate).toISOString(),
	});
	const datefilter = listOnly ? {} : {
		start: startOfDay(oneDayAgoDate).toISOString(),
		end: endOfDay(todayDate).toISOString(),
	}
	const filterRef = useRef({...defaultFilter, plantId: plantArray ? [] :plantId, ...datefilter});
	const {
		socketData: { checkpointEvents: _checkpointEvents },
	} = useSocketContext();
	let checkpointEvents = useMemo(() => {
		return deduplicateEntries(_checkpointEvents);
	}, [_checkpointEvents]);
	const { page_no, pagesize } = filterRef.current;
	const { getCheckpointDataListForExcelDownload, message, error}= useCheckpointDataForExcelDownload()
	const { trigger, checkpointData, isLoading: isCheckpointDataLoading, tableHeader, count } = useCheckpointData(filterRef.current);
	const [vehicleDetailTrigger, { data: vehicleDetail, isLoading: vehicleDetailLoading }] = useVehicleDetailsMutation();
	const { userDetail } = useUserDetail();
	const { userPermissions } = useUserPermissions();
	const { userTableHeaders, getUserTableHeaders } = useUserTableHeader();
	const [updateTableHeader] = useUpdateUserTableHeadersMutation();

	const { checkoutConfigMap } = useCheckpoints();
	const [isDetail, setIsDetail] = useState(null);
	const { plantOptions } = usePlant({});
	const [getDetail, { data, isFetching: isFetchingDetail }] = useLazyGetCheckpointEntryDetailQuery();
	let { data: detailData, tableHeader: detailTableHeaders, historicalDataHeaderMap } = data || { tableHeader: [] };
	const isHistoricalHeadersLoading = !historicalDataHeaderMap && isFetchingDetail;
	const isVehicleNumberEditable = detailData?.trip_over === false && detailData?.statusHistory?.[0]?.type === "camera" && !!userPermissions?.updateVehicleNumber?.value && userDetail?.userRoleHierarchy === 0;
	const excelColumnList = Array.isArray(userTableHeaders)? userTableHeaders : userTableHeaders?.data || [];
	const [openExcelDialog, setOpenExcelDialog] = useState(false);
	const [selectedExcelHeaders, setSelectedExcelHeaders] = useState([]);
	const [excelDateFilter, setExcelDateFilter] = useState({
		start: startOfDay(oneDayAgoDate).toISOString(),
		end: endOfDay(todayDate).toISOString(),
	});

	// Vehicle number edit dialog state
	const [editVehicleDialogOpen, setEditVehicleDialogOpen] = useState(false);
	const [editVehicleData, setEditVehicleData] = useState(null);

	const handleVehicleNumberEdit = (tripData) => {
		setEditVehicleData(tripData);
		setEditVehicleDialogOpen(true);
	};

	const toggleExcelColumn = (col) => {
		setSelectedExcelHeaders((prev) =>
			prev.some((h) => h.key === col.key)
				? prev.filter((h) => h.key !== col.key)
				: [...prev, col]
		);
	};

	const handleSelectAllExcel = () => setSelectedExcelHeaders(excelColumnList);
	const handleClearAllExcel = () => setSelectedExcelHeaders([]);
	const excelHeaders = selectedExcelHeaders.map(h => h.label);

	const handleDetailClose = () => {
		setIsDetail(false);
	};
	const fetchTable = (updatedPlantId) => {
		// console.log('fetching table for: ', index, dataSet[index])
		filterRef.current = { ...filterRef.current, templateId: "default-dashboard-listing", checkpointId: "all", type: "arrived", orgId: userDetail?.orgId };
		if (plantArray) {
			filterRef.current.plantId = [];
		} else if (updatedPlantId) {
			filterRef.current.plantId = [updatedPlantId];
		}
		if (listOnly) {
			filterRef.current.trip_status = "Ongoing";
		}
		trigger(filterRef.current);
	};
	useEffect(() => {
		if (onTotalCountChange && typeof count === "number") {
			onTotalCountChange(count);
		}
	}, [count, onTotalCountChange]);
	useEffect(() => {
		fetchTable();
		const intervalId = setInterval(() => {
			trigger(filterRef.current);
		}, 90000);
		return () => clearInterval(intervalId);
	}, []);
	useEffect(() => {
		if (plantId) {
			fetchTable(plantId);
			setIsDetail(false);
		}
	}, [plantId]);
	useEffect(() => {
		getUserTableHeaders({ template_id: "default-dashboard-listing" });
	}, []);
	// useEffect(() => {
	// 	if (checkpointEvents.length > 0) {
	// 		fetchTable();
	// 	}
	// }, [checkpointEvents]);

	const handleChange = (value, key) => {
		// console.log("filter on change", { [key]: value });
		setFilter((previous) => {
			return { ...previous, [key]: value === null ? "" : value };
		});
	};

	const handleSubmit = () => {
		if (Object.keys(filter)?.length > 0) {
			if (Object.keys(filter).includes("start") || Object.keys(filter).includes("end")) {
				filterRef.current = { ...filterRef.current, ...{ start: filter?.start ? startOfDay(new Date(filter.start)).toISOString() : "", end: filter?.end ? endOfDay(new Date(filter.end)).toISOString() : "",} };
			}
			if (Object.keys(filter).includes("productName") || Object.keys(filter).includes("productCategory")) {
				filterRef.current = {
					...filterRef.current,
					...{
						searchBy: filter?.productName ? "product.productName" : filter?.productCategory ? "productCategory.productCategory" : "",
						search: filter.productName || filter?.productCategory || "",
					},
				};
			}
			filterRef.current = {
				...filterRef.current,
				plantId: filter?.plantId ? filter.plantId.map((p) => p.value) : [],
			};
			if (filter.trip_status) {
				filterRef.current.trip_status = filter.trip_status;
			}else{
				delete filterRef.current.trip_status
			}
			if (filter.entry_mode) {
				filterRef.current.entry_mode = filter.entry_mode;
			}else{
				delete filterRef.current.entry_mode
			}
		} else {
			filterRef.current = { ...filterRef.current, ...{ searchBy: "", search: "", start: "", plantId: [] } };
		}
		// console.log("filter on submit", filterRef.current, filter);
		filterRef.current.page_no = 1;
		trigger(filterRef.current);
	};

	const onClear = () => {
		setFilter({ plantId: [] });
		// filterRef.current = { ...filterRef.current, ...{ searchBy: [], search: [], start: "" } };
		filterRef.current = {
			...defaultFilter,
			templateId: "default-dashboard-listing",
			checkpointId: "all",
			type: "arrived",
			orgId: userDetail?.orgId,
			plantId: [],
		};
		trigger(filterRef.current);
	};

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		trigger(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value, page_no: 1 };
		trigger(filterRef.current);
	};
	const handlePopOver = (event, id) => {
		event.stopPropagation();
		if(listOnly && handletripDetail){
			handletripDetail(id);
		}else{
			setAnchorEl(event.currentTarget);
			// console.log("event", id);
			vehicleDetailTrigger({ vehicleEntryId: id });
		}
		
	};

	const handleClosePopOver = () => {
		setAnchorEl(null);
	};
	const onUpdateSuccess = () => {
		getUserTableHeaders({ template_id: "default-dashboard-listing" });
	};
	const updateTableColumn = async (selectedArray) => {
		const updateTableHeaderPayload = {
			template_id: "default-dashboard-listing",
			selected_headers: selectedArray,
		};
		if (updateTableHeaderPayload) {
			const {
				data: { error, message },
			} = await updateTableHeader(updateTableHeaderPayload);
			if (error) {
				toastMessage(false, message);
			} else {
				toastMessage(true, message);
				onUpdateSuccess();
				fetchTable();
			}
		}
	};
	// console.log("FILTEREF", filterRef.current)
	const checkCheckpointData = (checkpointEvents, checkpointData) => {
		if (!checkpointData || !checkpointData.length) {
			const selectedPlantIds = filterRef.current.plantId || [];
			// return [...checkpointEvents];
			// if no selected plants -> show all events
			// if selected plants -> show filtered by plants
			return checkpointEvents.filter(event =>
				 selectedPlantIds.includes(event.plantId)
		);
		}
					// If noSocketEvent is true >>>> completely ignore socket data and show checkpoint data in case of manage trip listing
			if (noSocketEvent) {
				return checkpointData || [];
			}
		let rangeCheckoutEvents = new Set();
		// we want to remove any entries from checkpointEvents that we already have in checkpointData
		// except for "range-checkout" events -> we want to keep this and remove the stale entry from checkpointData;
		// uniqueElements will have -> unique events that dont exist in checkpointData + rangeCheckout events that exist in checkpointData
		const uniqueElements = checkpointEvents.filter((event) => {
			if(filterRef.current.plantId?.length){
				return filterRef.current.plantId.includes(event.plantId)
			}
			else if (event.SOCKET_EVENT_TYPE == "range-checkout") {
				rangeCheckoutEvents.add(event._id);
			} else {
				return !checkpointData.some((item) => item._id === event._id);
			}
			return true;
		});

		// we filter checkpointData to remove any entries whose rangeCheckout event entry exists;
		checkpointData = checkpointData.filter((trip) => !rangeCheckoutEvents.has(trip._id));
		let result = [...uniqueElements, ...checkpointData];

		return result;
	};

	// Handle Excel Download with loading toast
	const handleExcelDownload = async () => {
		if (!selectedExcelHeaders.length) {
			toastMessage(false, "Please select at least one column");
			return;
		}

		// Validate date range - should not exceed 3 days
		const startDate = new Date(excelDateFilter.start);
		const endDate = new Date(excelDateFilter.end);
		const diffInMs = endDate - startDate;
		const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

		if (diffInDays > 3) {
			toastMessage(false, "Date range should not exceed 3 days. Please select a shorter duration.");
			return;
		}

		// Close dialog immediately
		setOpenExcelDialog(false);

		// Show loading toast
		toastMessage("loading", "Your report is in progress, will download soon...", { 
			position: "bottom-right", 
			autoClose: 300000, 
			closeOnClick: true 
		});

		try {
			const excelFilter = {
				...filterRef.current,
				start: excelDateFilter.start,
				end: excelDateFilter.end,
				pagesize: 1000000,
				page_no : 1
			};

			// Fetch data from API
			const result = await getCheckpointDataListForExcelDownload(excelFilter);
			const fullData = Array.isArray(result?.data)
				? result.data
				: Array.isArray(result?.data?.data)
				? result.data.data
				: [];

			// Dismiss loading toast
			toast.dismiss();

			if (!fullData || fullData.length === 0) {
				toastMessage(false, "No data found for the selected date range");
				return;
			}

			const headers = selectedExcelHeaders.map(h => h.label);

			const rows = fullData?.map(row =>
				selectedExcelHeaders.map(h => {
					const cleanKey = h.key.replace("$dynamicKey.", "");
					return findDeepValue(row, cleanKey.split(".")) || "-";
				})
			);

			downloadExcel({
				fileName: "Checkpoint_Report",
				sheet: "Checkpoint_Report",
				tablePayload: {
					header: headers,
					body: rows
				}
			});

			// Show success toast
			toastMessage(true, "Excel report downloaded successfully!");

		} catch (error) {
			console.error("Excel download error:", error);
			// Dismiss loading toast and show error
			toast.dismiss();
			toastMessage(false, "Failed to download Excel report. Please try again.");
		}
	};

	const openPopOver = Boolean(anchorEl);
	const popOverId = open ? "simple-popover" : undefined;
	let actionHandlers = {
		view: async (dataEntry) => {
			const { _id } = dataEntry;
			//harcoding for vehicle entry detail.
			const payload = { vehicleEntryId: _id };
			// console.log("DATA ENTRY ID", payload)
			getDetail(["vms/vehicle/vehicle-entry-data-list", payload]);
			setIsDetail(true);
		},
	};
	let header = ["S.No", ...(tableHeader || []).map((_) => _.label)];
	header.push("Action");
	let handlers = { ...actionHandlers };
	const filteredCheckpointData = checkpointData?.length > 0 || checkpointEvents?.length > 0 ? checkCheckpointData(checkpointEvents, checkpointData) : [];
	// const filteredCheckpointData = checkpointData?.length > 0 ? checkpointData.filter((item2) => !checkpointEvents.some((item1) => item1._id === item2._id)) : []; // here filter socket data from api data.
	//[...filteredCheckpointData]
	let rows =
		(shouldRunTour || isTourMode ? dummyTourData : checkpointData)?.map((data, index) => {
			let row = [tCell(index + 1)];
			// for showing the latest socket event bg color in table listing
			row.bgColor = data.bgColor;
			for (let item of tableHeader) {
				let value = findDeepValue(data, item.name.split(".")) || "-";
				if (value == "-") {
					value = findDeepValue(data.formData, item.name.split("."));
				}

				if (typeof value == "object") {
					value = JSON.stringify(value);
				} else {
					value = capitalizeCamelCase(value);
				}
				if (item.type == "icon") {
					value = dataIconMap[value] || value;
				}

				if (item.name === "vehicleNumber") {
					row.push(tCell(value, theme.themeOrange, "pointer", handlePopOver, data._id));
				} else {
					row.push(tCell(item.type === "date" ? formatDate(value, item.format) : value));
				}
			}
			const formattedStatus = capitalizeCamelCase(removeSpecialChars(data.approvalStatus));
			const approvalStatus = (
				<span className={`status ${!data.hasOwnProperty("isApproved") ? "Yellow" : data.isApproved ? "green" : "red"}`} title={formattedStatus}>
					{formattedStatus}
				</span>
			);
			let submittedText = "";
			if (filterRef.current?.type === "pending") {
				submittedText = "";
			} else {
				submittedText = tCell(<span className="status green">Submitted</span>);
			}
			const action = (
				<div>
					<div className="eyeIcon" onClick={() => handlers.view(data)}>
						<EyeIcon className="view_icon" />
					</div>
				</div>
			);
			row.push(action);
			return row;
		}) || [];

	return (
		<>
			{listOnly ? null : (
				<>
					<div className="table-header-container">
						<div>{showHeading ? <h5>All Checkpoint Data</h5> : null}</div>
						<div style={{ display: "flex", gap: "1rem"}}>
							{
								showDownloadExcelButton && (
									<div style={{minWidth:"120px"}}>
										<Button
											style={buttonClasses.lynkitOrangeFill}
											text={"Download Excel"}
											onClick={() => {
												setSelectedExcelHeaders(excelColumnList);
												setOpenExcelDialog(true);
											}}
										/>		
									</div>
								)
							}
							
							<div className="checkpointTableHeader">
								<TableColumnCustomizer tableColumList={userTableHeaders} onApply={(selected) => updateTableColumn(selected)} />
							</div>

							<Button
								style={buttonClasses.lynkitBlackEmpty}
								text={"View Details"}
								onClick={() => {
									navigate(forwordLink);
								}}
							/>
						</div>
					</div>
					<div className="checkpointFilter">
						{plantOptions?.length > 1 ? (
							<Dropdown
								name="plantId"
								value={Array.isArray(filter?.plantId) ? filter.plantId : []}
								onChange={(val) => handleChange(val, "plantId")}
								options={plantOptions}
								label="Warehouses"
								multiple
							/>
						) : null}
						<SearchDropdown
							id={"dashboard-product-filter-dropdown"}
							name="productfilter"
							options={[
								{ label: "Product Name", value: "productName" },
								{ label: "Product Categories", value: "productCategory" },
							]}
							label={"Product / Product Categories"}
							placeholder={"Enter value"}
							value={filter}
							Debounce={true}
							onChange={(value, key) => handleChange(value, key)}
							onhandleClear={onClear}
						/>
						<DatePicker
							name={"start"}
							maxDATE={dayjs()}
							value={filter?.start ? dayjs(filter.start) : null}
							required
							onChange={(val) => handleChange(val.toISOString(), "start")}
							label={"Start Date"}
						/>
						<DatePicker
							name={"end"}
							minDATE={filter?.start ? dayjs(filter?.start) : null}
							maxDATE={dayjs()}
							value={filter?.end ? dayjs(filter.end) : null}
							required
							onChange={(val) => handleChange(val.toISOString(), "end")}
							label="End Date"
						/>
						<Dropdown
							name="trip_status"
							value={tripStatusOps.find((_) => _.value == filter.trip_status) || null}
							onChange={(val) => handleChange(val?.value || "", "trip_status")}
							options={tripStatusOps}
							label="Trip Status"
						/>
						<Dropdown
							name="entry_mode"
							value={entryModeOpts.find((_) => _.value == filter.entry_mode) || null}
							onChange={(val) => handleChange(val?.value || "", "entry_mode")}
							options={entryModeOpts}
							label="Entry Mode"
						/>
						<div className="alltrip_filter_btns">
							<Button testId="Clear" text="Clear" style={buttonClasses.lynkitOrangeEmpty} onClick={onClear} />
							<Button
								testId="Submit"
								text="Apply Filter"
								style={buttonClasses.lynkitOrangeFill}
								disabled={!Object.values(filter).some((value) => value !== null && value !== undefined && value !== "")}
								onClick={handleSubmit}
							/>
						</div>
					</div>
				</>
			)}
			<div id="checkpointTable">
				{isCheckpointDataLoading ? (
					<Loader size="3rem" height="100%" />
				) : (
					<div className="main_content" style={{ width: "100%" }}>
						<GenericTable
							header={header}
							rows={rows}
							TableData={checkpointData} //[...checkpointEvents, ...filteredCheckpointData]
							// pageCount={count}
							// pageNo={page_no}
							// limit={pagesize}
							// onPageChange={onPageChange}
							// onPageSizeChange={onPageSizeChange}
							isLoading={isCheckpointDataLoading}
							{...(showPagination && {
								pageCount: count,
								pageNo: page_no,
								limit: pagesize,
								onPageChange,
								onPageSizeChange,
							})}
						/>
						<div id="cpdetails">
							<div className={`detail_card ${isDetail ? "open" : ""}`}>
								{isDetail && (
									<Card sx={{ borderRadius: "12px", overflow: "hidden" }}>
										{isFetchingDetail || !historicalDataHeaderMap ? (
											// Show skeleton while loading
											<VehicleJourneyDetailSkeleton
												isOpen={isDetail}
												onClose={handleDetailClose}
												height="75vh"
											/>
										) : (
											// Show actual content when loaded
											<VehicleJourneyDetailCard
												isOpen={isDetail}
												onClose={handleDetailClose}
												data={detailData}
												tableHeader={detailTableHeaders}
												historicalDataHeaderMap={historicalDataHeaderMap}
												inTimeOutTimeConfig={checkoutConfigMap}
												height="75vh"
												isVehicleNumberEditable={isVehicleNumberEditable}
												handleVehicleNumberEdit={handleVehicleNumberEdit}
											/>
										)}
									</Card>
								)}
							</div>
						</div>
					</div>
				)}
			</div>
			<PopOver id={popOverId} open={openPopOver} anchorEl={anchorEl} onClose={handleClosePopOver}>
				{vehicleDetailLoading ? (
					<p>loading.....</p>
				) : vehicleDetail?.data?.statusHistory ? (
					<div className="dashboard-popover-container">
						<div className="status-history">
							<span>Status History</span>
						</div>
						{vehicleDetail?.data?.statusHistory.map((ele, index) => {
							const { hideInTime = false, hideOutTime = false, inTimeLabel = "In Time", outTimeLabel = "Out Time" } = checkoutConfigMap[ele.checkpointId] || {};
							return (
								<div className="dashboard-status-card" key={ele._id}>
									<div className="dashboard-status-card-uppper">
										<div className="dashboard-status-card-uppper-left">
											<div className="dot">
												<CheckIcon fontSize={"10px"} htmlColor={"#fff"} />
											</div>
											<div className="arrow"></div>
										</div>
										<div className="dashboard-status-card-uppper-right">
											<div className="content-header">
												<span>{ele.displayName}</span>
											</div>
											<div className="content-detail">
												{!hideInTime ? (
													<>
														<span className="title">{inTimeLabel} :</span>
														<span className="detail">{formatDate(ele.inTime)}</span>
													</>
												) : null}
												<br />
												{!hideOutTime ? (
													<>
														<span className="title">{outTimeLabel} : </span>
														<span className="detail">{formatDate(ele.outTime)}</span>
													</>
												) : null}

												<br />
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				) : null}
			</PopOver>

			{/* Excel Download Dialog */}
			<Dialog
				open={openExcelDialog}
				handleClose={() => setOpenExcelDialog(false)}
				title="Download Excel"
				size="md"
				handleCancel={() => setOpenExcelDialog(false)}
				handleSubmit={handleExcelDownload}
				SubmitText="Download"
			>
				<div style={{ margin: "0px 0px 10px 0px" }}>
					Select Duration and keys to download and share all trip detail
				</div>
				<div style={{ display: "flex", marginBottom: 12, gap:"1rem", maxWidth:"290px" }}>
					<Button
						text="Select All"
						style={buttonClasses.lynkitBlackEmpty}
						onClick={handleSelectAllExcel}
					/>
					<Button
						text="Clear All"
						style={buttonClasses.lynkitBlackEmpty}
						onClick={handleClearAllExcel}
					/>
				</div>
				<div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
					<DatePicker
						name="excelStart"
						maxDATE={dayjs()}
						value={excelDateFilter.start ? dayjs(excelDateFilter.start) : null}
						onChange={(val) =>
							setExcelDateFilter((prev) => ({
								...prev,
								start: startOfDay(val.toDate()).toISOString(),
							}))
						}
						label="Start Date"
					/>
					<DatePicker
						name="excelEnd"
						minDATE={excelDateFilter.start ? dayjs(excelDateFilter.start) : null}
						maxDATE={excelDateFilter.start? dayjs(excelDateFilter.start).add(2, "day"): dayjs()}
						value={excelDateFilter.end ? dayjs(excelDateFilter.end) : null}
						onChange={(val) =>
							setExcelDateFilter((prev) => ({
								...prev,
								end: endOfDay(val.toDate()).toISOString(),
							}))
						}
						label="End Date"
					/>
				</div>
				<Grid container spacing={1}>
					{excelColumnList.map((h) => (
						<Grid item xs={4} key={h.key}>
							<Checkbox
								label={h.label}
								checked={selectedExcelHeaders.some(s => s.key === h.key)}
								onChange={() => toggleExcelColumn(h)}
							/>
						</Grid>
					))}
				</Grid>
			</Dialog>

			{/* Vehicle Number Edit Dialog */}
			<EditVehicleDialog
				open={editVehicleDialogOpen}
				onClose={() => {
					setEditVehicleDialogOpen(false);
					setEditVehicleData(null);
				}}
				tripData={editVehicleData}
				onSuccess={() => {
					setIsDetail(false);
					trigger(filterRef.current);
				}}
			/>
		</>
	);
}

const tripStatusOps = [
	{ label: "Ongoing", value: "Ongoing" },
	{ label: "Terminated", value: "Terminated" },
	{ label: "Cancelled", value: "Cancelled" },
	{ label: "Completed", value: "Completed" },
];

const entryModeOpts = [
	{ label: "ANPR", value: "camera" },
	{ label: "RFID", value: "scan" },
	{ label: "Manual", value: "manual" },
];
